export function factoringTableConfig(getMoney) {
  return {
    menuType: "button",
    addBtn: false,
    menuWidth: 120,
    menuAlign: "center",
    card: true,
    menu: false,
    refreshBtn: false,
    delBtn: false,
    editBtn: false,
    align: "center",
    searchMenuSpan: 8,
    columnBtn: false,
    searchBtn: false,
    index: true,
    indexLabel: "序号",
    selection: true,
    selectionWidth: 45,
    labelWidth: 150,
    showSummary: true,
    sumColumnList: [
      {
        name: "totalAssets",
        overHidden: true,
        type: "sum",
      },
      {
        name: "netAssets",
        overHidden: true,
        type: "sum",
      },
      {
        name: "businessIncome",
        overHidden: true,
        type: "sum",
      },
      {
        name: "netProfit",
        overHidden: true,
        type: "sum",
      }
      
    ], 
    column: [{
        label: "财报标题",
        prop: "name",
        display: false,
        width: "150",

      }, {
        label: '总资产（万元）',
        prop: "totalAssets",
        width: "150",
        display: false,
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}万元`;
        }
      }, {
        label: '净资产（万元）',
        prop: "netAssets",
        width: "150",
        display: false,
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}万元`;
        }
      },
      {
        label: '营业收入（万元）',
        prop: "businessIncome",
        width: "150",
        display: false,
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}万元`;
        }
      },
      {
        label: '净利润（万元）',
        prop: "netProfit",
        width: "150",
        display: false,
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}万元`;
        }
      }, {
        label: "报表类型",
        prop: "type",
        type: "select",
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=bl_financial_type",
        props: {
          label: "dictValue",
          value: "dictKey"
        },
        dataType:'number',
        width: 120,
        rules: [{
          required: true,
          message: "请选择报表类型",
          trigger: "blur",
        }, ],

      }, {
        label: "报告类型",
        prop: "reportType",
        type: "select",
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=bl_financial_report_type",
        props: {
          label: "dictValue",
          value: "dictKey"
        },

        width: 120,
        dataType:'number',
        rules: [{
          required: true,
          message: "请选择报告类型",
          trigger: "blur",
        }, ],

      }, {
        label: "所属周期",
        prop: "cycle",
        type: "select",
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=bl_financial_cycle",
        width: 120,
        dataType:'number',
        props: {
          label: "dictValue",
          value: "dictKey"
        },
        rules: [{
          required: true,
          message: "请选择所属周期",
          trigger: "blur",
        }, ],

      }, {
        label: "报告日期",
        prop: "reportDate",
        type: "date",
        rules: [{
          required: true,
          message: "请选择报告日期",
          trigger: "blur",
        }, ],
        width: 120,
        format: "yyyy-MM-dd",
        valueFormat: "yyyy-MM-dd",
      }, {
        label: "财报标题",
        prop: "cycleReportDate",
        placeholder: "等待生成",
        disabled: true,
        hide: true

      }, {
        label: "是否为合并报表",
        prop: "isConsolidated",
        type: "radio",
        span: 12,
        width: 200,
        dicData: [{
            label: "否",
            value: 0,
          },
          {
            label: "是",
            value: 1,
          },

        ],
        value: 0,
        rules: [{
          required: true,
          message: "请选择是否为合并报表",
          trigger: "blur",
        }, ],
      },
      {
        label: '财务报表',
        prop: 'fileCwbb',
        formslot: true,
        span: 12,
        hide: true,
        rules: [{
          required: true,
          message: "请上传财务报表",
        }, ],
      }, {
        label: '财务报告附件',
        prop: 'fileCwbg',
        formslot: true,
        span: 12,
        hide: true
      },
    ]
  }
}
